import React from 'react';
import S from './GatedContent.styles';
const GatedContent = ({ cta1, cta2, content, summary, title }) => {
    return (React.createElement(React.Fragment, null,
        summary &&
            React.createElement(S.SummaryArea, { padding: true },
                React.createElement(S.SummaryGrid, null,
                    React.createElement(S.SummaryColumn, null,
                        React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: summary } })))),
        React.createElement(S.Container, { padding: true },
            React.createElement(S.Inner, null,
                React.createElement(S.Title, null, title),
                React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: content } }),
                React.createElement(S.Cta1, { "aria-label": cta1.accessibleText, href: cta1.url, target: cta1.target, themeOption: cta1.themeOption, title: cta1.text }),
                cta2 && (React.createElement(S.Cta2, { "aria-label": cta2.accessibleText, href: cta2.url, target: cta2.target }, cta2.text))))));
};
export default GatedContent;
